import { useEffect, useState } from 'react';

import './App.scss';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Home from './pages/Home';
import Product from './pages/Product';
import About from './pages/About';
import EshopPetit from './pages/EshopPetit';
import EshopMoyen from './pages/EshopMoyen';
import EshopGrand from './pages/EshopGrand';

import client from './contentfulClientToken.js';
import Menu from './components/Menu.js';
import PageTransition from './components/PageTransition.js';
import CustomCursor from './components/CustomCursor.js';
// import Home02 from './pages/Home02.js';

function App() {

  const [homePage, setHomePage] = useState({ products: [], allPhotos: [] });
  const [eshopPage, setEshopPage] = useState({ products: [], allPhotos: [] });
  const [aboutPage, setAboutPage] = useState([]);
  const [eshopInfo, setEshopInfo] = useState(null);
  const [eshopProductsLoaded, setEshopProductsLoaded] = useState(false);

  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };
    document.addEventListener('contextmenu', handleContextMenu);
    return () => document.removeEventListener('contextmenu', handleContextMenu);
  }, []);

  useEffect(() => {
    const fetchHomePage = async () => {
      try {
        const response = await client.getEntry('ata0RcVIfezbpXVxcUyV8', { include: 3 });
        //console.log('Fetched Home Page data:', response);

        const items = response?.fields?.homePageImages || [];


        const normalizeStock = (value) => {
          if (typeof value === 'boolean') return value;
          if (typeof value === 'string') {
            const s = value.trim().toLowerCase();
            return s === 'true' || s === '1' || s === 'yes' || s === 'oui';
          }
          if (typeof value === 'number') return value > 0;
          return false;
        };

        const products = items
          .map((item) => {
            const fields = item?.fields || {};

            const singleAsset = fields.photoSeule;
            const singleUrl = singleAsset?.fields?.file?.url;
            const src = singleUrl ? (singleUrl.startsWith('http') ? singleUrl : `https:${singleUrl}`) : '';


            const multiAssets = Array.isArray(fields.photoMultiple) ? fields.photoMultiple : [];
            const photos = multiAssets.filter(a => a?.fields?.file?.url);

            const captionParts = [
              fields.titre,
              fields.taille,
              fields.type,
              fields.matiere,
              fields.teinture,
              fields.prix,
            ]
              .filter(Boolean)
              .map((s) => (typeof s === 'string' ? s.trim() : s));

            const caption = captionParts.join(' — ');

            const urlSlug = fields.url || item?.sys?.id || fields.titre || src;
            return {
              id: item?.sys?.id,
              url: urlSlug,
              src,
              asset: singleAsset,
              caption,
              photos,
              titre: fields.titre || '',
              taille: fields.taille || '',
              type: fields.type || '',
              matiere: fields.matiere || '',
              teinture: fields.teinture || '',
              categorie: fields.categorie || [],
              stock: normalizeStock(fields.stock),
              productComponentId: fields.productComponentId,
              shopifyBuyId: fields.shopifyBuyId,
              path: `/${urlSlug}`,
            };
          })
          .filter((p) => p.src);

        // Create flat pool of all photoMultiple images with product references
        const allPhotos = [];
        items.forEach((item) => {
          const fields = item?.fields || {};
          const multiAssets = Array.isArray(fields.photoMultiple) ? fields.photoMultiple : [];

          multiAssets.forEach((asset) => {
            const url = asset?.fields?.file?.url;
            const photoUrl = url ? (url.startsWith('http') ? url : `https:${url}`) : null;
            if (photoUrl) {
              const captionParts = [
                fields.titre,
                fields.taille,
                fields.type,
                fields.matiere,
                fields.teinture,
                fields.prix,
              ]
                .filter(Boolean)
                .map((s) => (typeof s === 'string' ? s.trim() : s));

              const urlSlug = fields.url || item?.sys?.id || fields.titre;

              allPhotos.push({
                id: `${item?.sys?.id}-${asset?.sys?.id}`,
                src: photoUrl,
                asset: asset,
                caption: captionParts.join(' — '),
                titre: fields.titre || '',
                taille: fields.taille || '',
                type: fields.type || '',
                matiere: fields.matiere || '',
                teinture: fields.teinture || '',
                stock: normalizeStock(fields.stock),
                path: `/${urlSlug}`,
              });
            }
          });
        });

        setHomePage({ products, allPhotos });


      } catch (error) {
        console.error('Error fetching Home Page data:', error);
      }
    };
    fetchHomePage();
  }, []);

  useEffect(() => {
    const fetchEshopProducts = async () => {
      try {
        const response = await client.getEntry('2Sns50U4GE1X9TvXcL7vVs', { include: 3 });
        console.log('Fetched eshop Page data:', response);

        const items = response?.fields?.eshopProducts || [];


        const normalizeStock = (value) => {
          if (typeof value === 'boolean') return value;
          if (typeof value === 'string') {
            const s = value.trim().toLowerCase();
            return s === 'true' || s === '1' || s === 'yes' || s === 'oui';
          }
          if (typeof value === 'number') return value > 0;
          return false;
        };

        const products = items
          .map((item) => {
            const fields = item?.fields || {};

            const singleAsset = fields.photoSeule;
            const singleUrl = singleAsset?.fields?.file?.url;
            const src = singleUrl ? (singleUrl.startsWith('http') ? singleUrl : `https:${singleUrl}`) : '';


            const multiAssets = Array.isArray(fields.photoMultiple) ? fields.photoMultiple : [];
            const photos = multiAssets.filter(a => a?.fields?.file?.url);

            const captionParts = [
              fields.titre,
              fields.taille,
              fields.type,
              fields.matiere,
              fields.teinture,
              fields.prix,
            ]
              .filter(Boolean)
              .map((s) => (typeof s === 'string' ? s.trim() : s));

            const caption = captionParts.join(' — ');

            const urlSlug = fields.url || item?.sys?.id || fields.titre || src;
            return {
              id: item?.sys?.id,
              url: urlSlug,
              src,
              asset: singleAsset,
              caption,
              photos,
              titre: fields.titre || '',
              taille: fields.taille || '',
              type: fields.type || '',
              matiere: fields.matiere || '',
              teinture: fields.teinture || '',
              categorie: fields.categorie || [],
              stock: normalizeStock(fields.stock),
              productComponentId: fields.productComponentId,
              shopifyBuyId: fields.shopifyBuyId,
              path: `/${urlSlug}`,
            };
          })
          .filter((p) => p.src);

        // Create flat pool of all photoMultiple images with product references
        const allPhotos = [];
        items.forEach((item) => {
          const fields = item?.fields || {};
          const multiAssets = Array.isArray(fields.photoMultiple) ? fields.photoMultiple : [];

          multiAssets.forEach((asset) => {
            const url = asset?.fields?.file?.url;
            const photoUrl = url ? (url.startsWith('http') ? url : `https:${url}`) : null;
            if (photoUrl) {
              const captionParts = [
                fields.titre,
                fields.taille,
                fields.type,
                fields.matiere,
                fields.teinture,
                fields.prix,
              ]
                .filter(Boolean)
                .map((s) => (typeof s === 'string' ? s.trim() : s));

              const urlSlug = fields.url || item?.sys?.id || fields.titre;

              allPhotos.push({
                id: `${item?.sys?.id}-${asset?.sys?.id}`,
                src: photoUrl,
                asset: asset,
                caption: captionParts.join(' — '),
                titre: fields.titre || '',
                taille: fields.taille || '',
                type: fields.type || '',
                matiere: fields.matiere || '',
                teinture: fields.teinture || '',
                stock: normalizeStock(fields.stock),
                path: `/${urlSlug}`,
              });
            }
          });
        });

        setEshopPage({ products, allPhotos });


      } catch (error) {
        console.error('Error fetching Eshop Products data:', error);
      } finally {
        setEshopProductsLoaded(true);
      }
    };
    fetchEshopProducts();
  }, []);

  useEffect(() => {
    const fetchAboutPage = async () => {
      try {
        const response = await client.getEntry('1DDitCDkxeaRnH1nynmeBC', { include: 3 });
        // console.log('Fetched About Page data:', response);

        const aProposItems = response?.fields?.aPropos || [];

        const processedItems = aProposItems.map((item) => {
          const fields = item?.fields || {};

          // Get images if they exist
          const images = Array.isArray(fields.image) ? fields.image.map((img) => {
            const url = img?.fields?.file?.url;
            return url ? (url.startsWith('http') ? url : `https:${url}`) : null;
          }).filter(Boolean) : [];

          return {
            id: item?.sys?.id,
            titre: fields.titre || '',
            texte: fields.texte || null,
            images: images
          };
        });

        setAboutPage(processedItems);

      } catch (error) {
        console.error('Error fetching About Page data:', error);
      }
    };
    fetchAboutPage();
  }, []);

  useEffect(() => {
    const fetchEshopSentence = async () => {
      try {
        const response = await client.getEntry('2naePEHPczhI2YKI4K0tu', { include: 3 });
        // console.log('Fetched Eshop Page data:', response);
        const phraseDoc = response?.fields?.phrase || null;
        setEshopInfo(phraseDoc);

      } catch (error) {
        console.error('Error fetching About Page data:', error);
      }
    };
    fetchEshopSentence();
  }, []);

  const AnimatedRoutes = () => {
    const location = useLocation();

    // Add body class based on current route
    useEffect(() => {
      if (location.pathname === '/about') {
        document.body.classList.add('about-page');
        document.body.classList.remove('eshop-page');
        document.body.classList.remove('product-page');
      } else if (location.pathname.match(/\/(petit-format|moyen-format|grand-format)$/)) {
        document.body.classList.add('eshop-page');
        document.body.classList.remove('about-page');
        document.body.classList.remove('product-page');
      } else if (location.pathname !== '/') {
        // Product page (catch-all route)
        document.body.classList.add('product-page');
        document.body.classList.remove('about-page');
        document.body.classList.remove('eshop-page');
      } else {
        document.body.classList.remove('about-page');
        document.body.classList.remove('eshop-page');
        document.body.classList.remove('product-page');
      }

      return () => {
        document.body.classList.remove('about-page');
        document.body.classList.remove('eshop-page');
        document.body.classList.remove('product-page');
      };
    }, [location.pathname]);

    return (
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<PageTransition><Home images={homePage.allPhotos || []} /></PageTransition>} />
          <Route path="/a-propos" element={<PageTransition><About items={aboutPage} /></PageTransition>} />
          <Route path="/petit-format" element={<PageTransition><EshopPetit products={eshopPage.products || []} eshopInfo={eshopInfo} /></PageTransition>} />
          <Route path="/moyen-format" element={<PageTransition><EshopMoyen products={eshopPage.products || []} eshopInfo={eshopInfo} /></PageTransition>} />
          <Route path="/grand-format" element={<PageTransition><EshopGrand products={eshopPage.products || []} eshopInfo={eshopInfo} /></PageTransition>} />
          <Route path="/:id" element={<PageTransition><Product products={eshopPage.products || []} productsLoaded={eshopProductsLoaded} /></PageTransition>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AnimatePresence>
    );
  };

  return (
    <BrowserRouter>
      <CustomCursor />
      <Menu />
      <AnimatedRoutes />
    </BrowserRouter>
  );
}

export default App;
